var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRbk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 38,
    viewBox: "0 0 141 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1715 0H0.0078125V34.8166L35.1715 0Z",
    fill: "#CDE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14453 38H38.2959V3.18954L3.14453 38Z",
    fill: "#CDE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7245 0.0487883H46.2852V37.9939H53.9666V23.8209H58.8907C67.8647 23.8209 73.0103 19.5519 73.0103 12.1178V11.9104C73.0041 4.37265 67.797 0.0487883 58.7245 0.0487883ZM65.495 12.1178C65.495 16.0575 63.1561 18.1371 58.7245 18.1371H53.9666V6.09854H58.7245C63.3346 6.09854 65.495 7.9281 65.495 11.9043V12.1178ZM91.7154 14.9536H85.4496V6.20831H102.124V0.0487883H77.8235V37.9939H91.5739C100.351 37.9939 105.386 33.7859 105.386 26.4494V26.2237C105.386 18.9665 100.536 14.9536 91.7154 14.9536ZM85.4311 20.6436H91.0999C95.7224 20.6436 97.9628 22.4731 97.9628 26.1871V26.3945C97.9628 30.1146 95.747 31.999 91.3646 31.999H85.4496L85.4311 20.6436ZM124.356 18.1675L140.223 0H131.791L117.88 16.3441V0.0487883H110.199V37.9939H117.88V21.1985L131.84 37.9939H140.993L124.356 18.1675Z",
    fill: "#CDE1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbk);
export default __webpack_public_path__ + "static/media/rbk.6383dcceadd00002500bee3bca4caf49.svg";
export { ForwardRef as ReactComponent };